// extracted by mini-css-extract-plugin
export var dividerText = "styles-module--dividerText--e2eac";
export var imgBlock = "styles-module--imgBlock--a0789";
export var linkBlock = "styles-module--linkBlock--948c3";
export var linkIcon = "styles-module--linkIcon--dbcbd";
export var rounded = "styles-module--rounded--d022e";
export var shareLinkeModalContent = "styles-module--shareLinkeModalContent--96eb4";
export var text = "styles-module--text--da3c4";